import { render, staticRenderFns } from "./nav-bar-courses.vue?vue&type=template&id=21f546f5"
import script from "./nav-bar-courses.vue?vue&type=script&lang=js"
export * from "./nav-bar-courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports